<template>
    <div class="container-fluid">
        <div class="tab-class text-center">
            <div class="tab-content">
            <div id="tab-1" class="tab-pane fade show p-0 active">
                <div class="row g-4">
                <div class="col-lg-12">
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.1s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-1.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.3s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-2.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.5s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-3.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.7s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-4.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.1s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-5.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.3s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-6.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.5s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-7.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3 wow bounceInUp" data-wow-delay="0.7s">
                            <div class="event-img position-relative">
                                <img class="img-fluid rounded w-100" src="@/assets/img/event-8.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>